import { useSelector } from "react-redux";
import Flx from "../../components/layout/Flx";
import Txt from "../../components/typography/Txt";

import { isEmpty, size } from "lodash";
import FlxGrid from "../../_src_shared/components/layout/FlxGrid";
import ScreenContent from "../../components/layout/ScreenContent";
import Htag from "../../components/typography/Htag";
import QuickActionSubmitFinancingRequest from "./sections/QuickActionSubmitFinancingRequest";

import ActionRequiredAlert from "../../components/alerts/ActionRequiredAlert";
import ProfileRequirementsAlert from "../../components/alerts/ProfileRequirementsAlert";
import QuickActionCompleteProfile from "./sections/QuickActionCompleteProfile";
import QuickActionUploadLoanDocuments from "./sections/QuickActionUploadLoanDocuments";
import DashboardSection from "./shared/DashboardSection";
import SubmittedFinancingRequestsSection from "./SubmittedFinancingRequestsSection";
import TitledHeader from "../../components/layout/TitledHeader";
import Screen from "../../components/layout/Screen";
import { Badge, Box, IconButton, Tooltip, Typography } from "@mui/material";
import {
  FeedOutlined,
  Notifications,
  NotificationsOutlined,
} from "@mui/icons-material";
import { useMemo, useRef } from "react";
import StyledMenu from "../../_src_shared/components/menus/StyledMenu";

const DashboardHomeScreen = () => {
  const profile = useSelector((state) => state?.profile);

  const financingRequests = useSelector((state) => state?.financingRequests);

  return (
    <Screen
      sx={{
        position: "absolute",
        left: 0,
        width: "100%",
        backgroundColor: "#f5f8fa",
        height: "100%",
      }}
    >
      {/* <TitledHeader
        endContent={<BorrowerNotificationsButton />}
        title={"Home"}
        // description="Please provide the necessary details to create a new loan."
      /> */}
      <ScreenContent
        maxWidth={"xl"}
        sx={{
          width: "100%",
          py: 4,
          margin: "0px auto",
        }}
      >
        <Flx column gap={2} fw>
          <Flx column fw gap={1}>
            <Flx column flexGrow={0} fw={false} gap={1}>
              <Flx fw jb ac>
                <Htag tag="h1" className="text-center">
                  Welcome, {profile?.firstName}!
                </Htag>
                <BorrowerNotificationsButton />
              </Flx>

              {isEmpty(financingRequests) ? (
                <Txt secondary>
                  To get started, submit your first financing request by
                  clicking the "Submit Financing Request" button below.
                </Txt>
              ) : (
                <Txt>
                  You currently have ({size(financingRequests)}) financing
                  requests in progress.
                </Txt>
              )}
              <ActionRequiredAlert />
              {/* <UnderwritingRequirementsAlert /> */}
              {/* <TermSheetReviewAlert /> */}
              {/* <ProfileRequirementsAlert /> */}
            </Flx>
          </Flx>
          {/* <DashboardWidgetsPreview /> */}
          <DashboardSection label={"Quick Actions"} sx={{ mt: 3 }}>
            <FlxGrid width="250px" gap={2} fw wrap>
              <QuickActionSubmitFinancingRequest />
              <QuickActionUploadLoanDocuments />
              {/* <QuickActionUploadProfileDocuments /> */}
              <QuickActionCompleteProfile />
            </FlxGrid>
          </DashboardSection>

          {/* <ActiveFinancingRequestsConditionsSection /> */}
          <SubmittedFinancingRequestsSection />
          {/* <OffMarketPropertyListingsSection /> */}
        </Flx>
      </ScreenContent>
    </Screen>
  );
};

const BorrowerNotificationsButton = () => {
  const anchorRef = useRef(null);
  const menuRef = useRef(null);
  const notificationCount = useMemo(() => {
    return 0;
  }, []);
  return (
    <>
      <IconButton
        size="small"
        ref={anchorRef}
        onClick={() => menuRef.current?.toggle()}
      >
        <Badge badgeContent={notificationCount} color="error">
          <NotificationsOutlined />
        </Badge>
      </IconButton>

      <StyledMenu
        ref={menuRef}
        anchorRef={anchorRef}
        title="Notifications"
        minWidth={340}
        maxWidth={400}
      >
        <Box sx={{ maxHeight: 400, overflowY: "auto" }}>
          {/* Empty state — swap this out when you wire up real notifications */}
          <Box sx={{ px: 2, py: 4, textAlign: "center" }}>
            <NotificationsOutlined
              sx={{ fontSize: 32, color: "#d1d5db", mb: 1 }}
            />
            <Typography sx={{ fontSize: 13, color: "#6b7280" }}>
              No new notifications
            </Typography>
          </Box>
        </Box>
      </StyledMenu>
    </>
  );
};

// Basic stat widget with icon

export default DashboardHomeScreen;
